import React, { useState } from "react";
import { Button, Card, Table, Tag } from "antd";
import { formatTimestamp, statusList } from "../../../../utils";
import { Gallery } from "../../../Orders/Gallery";

export const PaidOrders = ({filteredOrdersByEnd}) => {
    const [receipts, setReceipts] = useState();
    const [openReceipt, setOpenReceipt] = useState(false);

    const selectReceipts = async (order) => {
        setReceipts(order.fileImage);
        setOpenReceipt(true);
    };

    const paidFilteredOrdersByEnd = filteredOrdersByEnd.filter(order => order.payment === "RECAUDADO" && order.status === "Entregado" && order.department === "LIMA");

  const columns = [
    {
        title: "Serial",
        dataIndex: "serial",
        key: "serial",
        width: 80,
        fixed: "left" 
      },
      {
          title: "Cliente",
          dataIndex: "customerName",
          key:"customerName",
          width: 300,
          fixed: "left"
        },
        {
            title: "Pago",
            dataIndex: "payment",
            key:"payment",
            width: 300,
          },
        {
            title: "Fecha Preparacion",
            dataIndex: "dateEnd",
            key:"dateEnd",
            width: 175,
            render: (_, record) => {
              return (
                <>
                  {typeof record.dateEnd !== "string" ? (
                    <span>{formatTimestamp(record.dateEnd, 'hour')}</span>
                  ) : null}
                </>
              );
            },
            sorter: (a, b) => b.dateStart.seconds - a.dateStart.seconds,
            defaultSortOrder: 'ascend',
          },
    
          {
            title: "Monto Venta",
            dataIndex: "saleAmount",
            key:"saleAmount",
            width: 130,
            render: (_, record) => {
              return <span>${record.saleAmount.toFixed(2)}</span>;
            },
          },
          {
            title: "Monto Envio",
            dataIndex: "shippingAmount",
            key:"shippingAmount",
            width: 130,
            render: (_, record) => {
              return <span>${record.shippingAmount.toFixed(2)}</span>;
            },
          },
          {
            title: "Comprobante",
            dataIndex: "fileImage",
            key:"fileImage",
            width: 200,
            editable: true,
            filters:[
              {
                text:"Sin comprobante",
                value:false,
              },
              {
                text:"Con comprobante",
                value:true,
              }
            ],
            onFilter:(value,record) => {
              return Boolean(record.fileImage.length) === value;
            },
            render: (_, record) => {
              return !record.fileImage || !record.fileImage.length ? (
                  <p>S/C</p>
              ) : (
                
                  <Button type="link" onClick={() => selectReceipts(record)}>
                    Visualizar
                  </Button>
                
              );
            },
          },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (_, record) => {
        return (
            <>
                {statusList[record.status] ? (
                    <Tag color={statusList[record.status].color}>{record.status}</Tag>
                ) : null}
            </>
        );
    },
    },
  ];

  return (
    <>
        <Card title={
            <div className="flex justify-between items-center">
              <div>
                Lista de ordenes entregadas y recaudadas
              </div>
              <div>
                {paidFilteredOrdersByEnd.length} Ordenes
              </div>
            </div>
        }>
            {paidFilteredOrdersByEnd.length === 0 ? (
                <p>No hay pedidos en este rango de fechas.</p>
            ) : (
                <>
                    <Table
                        bordered
                        dataSource={paidFilteredOrdersByEnd}
                        columns={columns}
                        pagination={{ pageSize: 10 }}
                        scroll={{ x: 1300, y: 500 }}
                    />
                    <Gallery
                        images={receipts}
                        isModalOpen={openReceipt}
                        setIsModalOpen={setOpenReceipt}
                    />
                </>
            )}
        </Card>
    </>
);

};






